import { Component, OnInit } from "@angular/core";
import { NbDialogRef, NbDialogService } from "@nebular/theme";
import { Router } from "@angular/router";
import { UserCompany } from "src/app/models/user-company.model";
import { User } from "src/app/models/user.model";
import { AuthService } from "src/app/services/auth.service";
import { UserService } from "src/app/services/user.service";
import { CompanyContextService } from "src/app/services/company-context.service";

@Component({
    selector: "app-company-selector-dialog",
    templateUrl: "./company-selector-dialog.component.html",
    styleUrls: ["./company-selector-dialog.component.scss"],
    standalone: false
})
export class CompanySelectorDialogComponent implements OnInit {
  public user: User | null = null;
  public companies: UserCompany[] = [];
  public currentCompanyId: number | null = null;
  public loading = false;

  constructor(
    protected dialogRef: NbDialogRef<CompanySelectorDialogComponent>,
    protected authService: AuthService,
    protected userService: UserService,
    protected router: Router,
    protected companyContextService: CompanyContextService,
    protected nbDialogService: NbDialogService,
  ) {}

  ngOnInit(): void {
    this.loading = true;

    // Refresh user info from API to ensure up-to-date data
    this.authService.refreshMe().subscribe(
      (success) => {
        // Reload user from updated cache
        this.user = this.authService.getUser();
        if (this.user) {
          this.companies = this.user.companies;
          this.currentCompanyId = this.user.currentCompanyId;
        }
        this.loading = false;
      },
      (error) => {
        // Fallback to cached data if API call fails
        this.user = this.authService.getUser();
        if (this.user) {
          this.companies = this.user.companies;
          this.currentCompanyId = this.user.currentCompanyId;
        }
        this.loading = false;
      },
    );
  }

  public selectCompany(company: UserCompany): void {
    if (this.loading || company.id === this.currentCompanyId) return;

    this.loading = true;
    this.userService.setCompany(company.id).subscribe(
      (success) => {
        if (success) {
          // Update auth service
          this.authService.updateCachedCompany(company.id);

          // Notify context service
          this.companyContextService.notifyCompanyChanged(company.id);

          // Close dialog
          this.dialogRef.close({ changed: true });

          // Navigate to /compare with reload trick to avoid white screen
          const currentUrl = this.router.url;
          if (currentUrl.startsWith("/compare")) {
            // Force reload by navigating away and back
            this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
              this.router.navigateByUrl("/compare");
            });
          } else {
            this.router.navigateByUrl("/compare");
          }
        } else {
          this.loading = false;
        }
      },
      (error) => {
        this.loading = false;
      },
    );
  }

  public closeAction(): void {
    this.dialogRef.close({ changed: false });
  }
}
